if (!customElements.get('ik-box-builder')) {
  customElements.define(
    'ik-box-builder',
    class extends HTMLElement {
      constructor() {
        super();
        this.minimum = Number(this.dataset.minimum || 1);
        this.currency = this.dataset.currency || 'EUR';
        this.products = Array.from(this.querySelectorAll('[data-box-product]'));
        this.submitButton = this.querySelector('[data-box-submit]');
        this.bindEvents();
        this.updateSummary();
      }

      bindEvents() {
        this.products.forEach((product) => {
          product.querySelector('[data-box-increase]')?.addEventListener('click', () => this.change(product, 1));
          product.querySelector('[data-box-decrease]')?.addEventListener('click', () => this.change(product, -1));
        });
        this.submitButton?.addEventListener('click', () => this.addToCart());
      }

      change(product, delta) {
        const output = product.querySelector('[data-box-quantity]');
        const decrease = product.querySelector('[data-box-decrease]');
        const next = Math.max(0, Number(output.value || output.textContent || 0) + delta);
        output.value = next;
        output.textContent = next;
        decrease.disabled = next === 0;
        product.classList.toggle('is-selected', next > 0);
        this.updateSummary();
      }

      selection() {
        return this.products
          .map((product) => ({
            id: Number(product.dataset.variantId),
            title: product.dataset.title,
            price: Number(product.dataset.price || 0),
            regime: product.dataset.regime,
            quantity: Number(product.querySelector('[data-box-quantity]')?.value || 0),
          }))
          .filter((item) => item.quantity > 0);
      }

      money(cents) {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: this.currency }).format(cents / 100);
      }

      updateSummary() {
        const selected = this.selection();
        const count = selected.reduce((sum, item) => sum + item.quantity, 0);
        const total = selected.reduce((sum, item) => sum + item.price * item.quantity, 0);
        const regimes = [...new Set(selected.map((item) => item.regime).filter(Boolean))];
        const complete = count >= this.minimum;

        this.querySelector('[data-box-count]').textContent = count;
        this.querySelector('[data-box-total]').textContent = this.money(total);
        this.querySelector('[data-box-regimes]').textContent = regimes.length ? regimes.join(' + ') : '—';
        this.querySelector('[data-box-heading]').textContent = count ? `${count} prodotti selezionati` : 'Inizia a comporla';
        this.querySelector('[data-box-message]').textContent = complete
          ? 'La quantità minima è stata raggiunta. Puoi aggiungere la selezione al carrello.'
          : `Aggiungi ancora ${this.minimum - count} prodotti per completare la box.`;
        this.submitButton.disabled = !complete;
      }

      async addToCart() {
        const items = this.selection().map((item) => ({ id: item.id, quantity: item.quantity }));
        if (!items.length || this.submitButton.disabled) return;

        const error = this.querySelector('[data-box-error]');
        error.hidden = true;
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        const originalLabel = this.submitButton.textContent;
        this.submitButton.textContent = 'Aggiunta in corso…';

        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) throw new Error('Non è stato possibile aggiungere la selezione.');
          window.location.href = this.dataset.cartUrl;
        } catch (exception) {
          error.textContent = exception.message || 'Si è verificato un errore. Riprova.';
          error.hidden = false;
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-busy');
          this.submitButton.textContent = originalLabel;
        }
      }
    },
  );
}
